module.exports = __webpack_public_path__ + "img/workshop.a35720a6.png";